{
  "DominantIndet": "T"
}